import { createFileRoute } from '@tanstack/react-router'

import { RiskSettingsPage } from '#features/settings/risk/risk-settings-page'

export const Route = createFileRoute('/_app/$workspace/settings/risk')({
  head: () => ({
    meta: [
      {
        title: 'Risk labels settings',
      },
    ],
  }),
  component: () => <RiskSettingsPage />,
})
